// Local tokens for the v2 onboarding flow. Mirrors src/theme/brand.ts but
// adds the gradient + motion presets used by this module specifically.

export const T = {
  bgPage: "#0B0F14",
  bgHero: "#000000",
  bgCard: "#111827",
  bgElev: "#1F2937",

  fg: "#FFFFFF",
  fg2: "rgba(255,255,255,0.70)",
  muted: "rgba(255,255,255,0.45)",
  faint: "rgba(255,255,255,0.30)",
  disabled: "rgba(255,255,255,0.18)",

  hairline: "rgba(255,255,255,0.08)",
  hairlineStrong: "rgba(255,255,255,0.16)",

  blue: "#3B82F6",
  lime: "#84CC16",
  success: "#22C55E",
  warn: "#F59E0B",
  danger: "#EF4444",

  // Primary CTA gradient — used sparingly per design system.
  ctaGrad: "linear-gradient(135deg, #84CC16 0%, #3B82F6 100%)",

  motion: "220ms cubic-bezier(0.32, 0.72, 0, 1)",
  focusRing: "0 0 0 3px rgba(59,130,246,0.35)",

  tabular: {
    fontVariantNumeric: "tabular-nums" as const,
    fontFeatureSettings: "'tnum' 1" as const,
  },
} as const;

export const radii = {
  xs: 6,
  sm: 8,
  md: 10,
  lg: 12,
  xl: 14,
  card: 18,
  hero: 24,
  pill: 999,
} as const;
